// Helper to strip sessionToken from participant objects
export function toPublicParticipant(p) {
    const { sessionToken: _, ...public_ } = p;
    return public_;
}
// Fee calculation with fractional claim support
export function calculateParticipantTotal(claimedItems, subtotal, total) {
    // Use integer math: (amount * numerator) / denominator
    const itemsTotal = claimedItems.reduce((sum, item) => {
        const numerator = item.portionNumerator ?? 1;
        const denominator = item.portionDenominator ?? 1;
        return sum + Math.round((item.amount * numerator) / denominator);
    }, 0);
    const feesPortion = subtotal > 0 ? (itemsTotal / subtotal) * (total - subtotal) : 0;
    return Math.round(itemsTotal + feesPortion);
}
// Payment link generators
export function generateVenmoLink(handle, amount, note) {
    const amountDollars = (amount / 100).toFixed(2);
    return `venmo://paycharge?txn=pay&recipients=${encodeURIComponent(handle)}&amount=${amountDollars}&note=${encodeURIComponent(note)}`;
}
export function generateCashAppLink(cashtag, amount) {
    const amountDollars = (amount / 100).toFixed(2);
    const tag = cashtag.startsWith('$') ? cashtag.slice(1) : cashtag;
    return `https://cash.app/$${tag}/${amountDollars}`;
}
export function generatePayPalLink(username, amount) {
    const amountDollars = (amount / 100).toFixed(2);
    return `https://paypal.me/${username}/${amountDollars}`;
}
// Utility functions
export function generateEventCode() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let code = '';
    for (let i = 0; i < 8; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
}
export function generateId() {
    return crypto.randomUUID();
}
